<template>
  <div v-if="!fetching" class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <button class="add-sessions" @click="handleCreatSessionModalClick">
          + CREATE SESSION
        </button>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Session"
              v-model="searchStr"
            />
          </label>
        </span>
      </div>

      <!-- 
    | Tabs
    |active will have active class
    -->
      <div class="tabs-filter">
        <b-button
          class="primary btn-round-fill"
          :class="{ active: activeTab == 'upcoming' }"
          @click="showTabSessions('upcoming')"
        >
          Upcoming
        </b-button>
        <b-button
          class="primary btn-round-fill"
          :class="{ active: activeTab == 'past' }"
          @click="showTabSessions('past')"
        >
          Past
        </b-button>
        <b-button
          class="primary btn-round-fill"
          :class="{ active: activeTab == 'cancelled' }"
          @click="showTabSessions('cancelled')"
        >
          Cancelled
        </b-button>
      </div>
      <div v-if="sessionsToDisplay.length > 0" class="faqs" role="tablist">
        <b-card no-body class="mb-1" v-for="(session, i) in results" :key="i">
          <b-card-header
            header-tag="header"
            :class="{ active: activeCollapse == 'faq' + i }"
            role="tab"
          >
            <b-button
              class="btn-collapse"
              block
              variant="collapse"
              v-b-toggle="'faq' + i"
            >
              <img
                v-if="session.user && session.user.imgURL"
                :src="session.user.imgURL"
                :alt="session.user.firstname"
              />
              <b-avatar
                v-else
                variant="secondary"
                :text="
                  getInitials(session.user.firstname, session.user.lastname)
                "
              ></b-avatar>
              <div>
                <span class="name">
                  {{
                    session.user.firstname + " " + session.user.lastname
                  }}</span
                >
                <span
                  v-if="session.user.email && session.user.phoneNumber"
                  class="email"
                >
                  {{ session.user.email + " " + session.user.phoneNumber }}
                </span>
                <span
                  v-if="session.user.email && !session.user.phoneNumber"
                  class="email"
                >
                  {{ session.user.email }}
                </span>
                <span
                  v-if="!session.user.email && session.user.phoneNumber"
                  class="email"
                >
                  {{ session.user.phoneNumber }}
                </span>
              </div>
            </b-button>
            <span class="datetime">
              {{ getTimeDateString(session._booked_at.toDate()) }}
            </span>
            <span
              class="edit"
              @click="showEditSession(i)"
              v-b-popover.top.hover="'Edit'"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <!-- <span
              class="delete"
              @click="showDeleteSession"
              v-b-popover.top.hover="'Delete'"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
                  fill="#EF5C4A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
                  fill="#EF5C4A"
                />
              </svg>
            </span> -->
            <span class="chevron" v-b-toggle="'faq' + i">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </b-card-header>
          <b-collapse :id="'faq' + i" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <div class="details">
                <div class="price">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00016 0.5C8.36835 0.5 8.66683 0.798477 8.66683 1.16667V15.8333C8.66683 16.2015 8.36835 16.5 8.00016 16.5C7.63197 16.5 7.3335 16.2015 7.3335 15.8333V1.16667C7.3335 0.798477 7.63197 0.5 8.00016 0.5Z"
                        fill="#65EA82"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.21218 4.04535C4.77478 3.48274 5.53785 3.16667 6.3335 3.16667H11.3335C11.7017 3.16667 12.0002 3.46514 12.0002 3.83333C12.0002 4.20152 11.7017 4.5 11.3335 4.5H6.3335C5.89147 4.5 5.46755 4.67559 5.15498 4.98816C4.84242 5.30072 4.66683 5.72464 4.66683 6.16667C4.66683 6.60869 4.84242 7.03262 5.15498 7.34518C5.46755 7.65774 5.89147 7.83333 6.3335 7.83333H9.66683C10.4625 7.83333 11.2255 8.1494 11.7882 8.71201C12.3508 9.27462 12.6668 10.0377 12.6668 10.8333C12.6668 11.629 12.3508 12.392 11.7882 12.9547C11.2255 13.5173 10.4625 13.8333 9.66683 13.8333H4.00016C3.63197 13.8333 3.3335 13.5349 3.3335 13.1667C3.3335 12.7985 3.63197 12.5 4.00016 12.5H9.66683C10.1089 12.5 10.5328 12.3244 10.8453 12.0118C11.1579 11.6993 11.3335 11.2754 11.3335 10.8333C11.3335 10.3913 11.1579 9.96738 10.8453 9.65482C10.5328 9.34226 10.1089 9.16667 9.66683 9.16667H6.3335C5.53785 9.16667 4.77478 8.8506 4.21218 8.28799C3.64957 7.72538 3.3335 6.96232 3.3335 6.16667C3.3335 5.37102 3.64957 4.60796 4.21218 4.04535Z"
                        fill="#65EA82"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>{{ session.plan.price }}</span>
                </div>
                <div class="time">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.00033 2.49984C4.68662 2.49984 2.00033 5.18613 2.00033 8.49984C2.00033 11.8135 4.68662 14.4998 8.00033 14.4998C11.314 14.4998 14.0003 11.8135 14.0003 8.49984C14.0003 5.18613 11.314 2.49984 8.00033 2.49984ZM0.666992 8.49984C0.666992 4.44975 3.95024 1.1665 8.00033 1.1665C12.0504 1.1665 15.3337 4.44975 15.3337 8.49984C15.3337 12.5499 12.0504 15.8332 8.00033 15.8332C3.95024 15.8332 0.666992 12.5499 0.666992 8.49984Z"
                      fill="#474D52"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.00033 3.83317C8.36852 3.83317 8.66699 4.13165 8.66699 4.49984V8.08781L10.9651 9.23689C11.2945 9.40154 11.4279 9.80199 11.2633 10.1313C11.0986 10.4606 10.6982 10.5941 10.3688 10.4295L7.70218 9.09612C7.47633 8.98319 7.33366 8.75235 7.33366 8.49984V4.49984C7.33366 4.13165 7.63214 3.83317 8.00033 3.83317Z"
                      fill="#474D52"
                    />
                  </svg>

                  <span>{{ session.plan.duration }} mins</span>
                </div>
              </div>
              <b-card-text>{{ session.plan.summary }}</b-card-text>
              <b-card-text>
                <div v-if="session.session_code" class="link">
                  <span class="link-title">
                    Link
                  </span>
                  <a
                    :href="
                      generateLink(session.profileName, session.session_code)
                    "
                    target="_blank"
                    >{{
                      generateLink(session.profileName, session.session_code)
                    }}</a
                  >

                  <!-- </transition> -->
                  <svg
                    v-b-popover.top.hover="link"
                    @click="
                      copytoClipboard(
                        generateLink(session.profileName, session.session_code)
                      )
                    "
                    @mouseleave="changeMessage"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.33301 7.16659C6.96482 7.16659 6.66634 7.46506 6.66634 7.83325V13.8333C6.66634 14.2014 6.96482 14.4999 7.33301 14.4999H13.333C13.7012 14.4999 13.9997 14.2014 13.9997 13.8333V7.83325C13.9997 7.46506 13.7012 7.16659 13.333 7.16659H7.33301ZM5.33301 7.83325C5.33301 6.72868 6.22844 5.83325 7.33301 5.83325H13.333C14.4376 5.83325 15.333 6.72868 15.333 7.83325V13.8333C15.333 14.9378 14.4376 15.8333 13.333 15.8333H7.33301C6.22844 15.8333 5.33301 14.9378 5.33301 13.8333V7.83325Z"
                      fill="#557EFB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.66699 2.50008C2.49018 2.50008 2.32061 2.57032 2.19559 2.69534C2.07056 2.82037 2.00033 2.98994 2.00033 3.16675V9.16675C2.00033 9.34356 2.07056 9.51313 2.19559 9.63815C2.32061 9.76318 2.49018 9.83342 2.66699 9.83342H3.33366C3.70185 9.83342 4.00033 10.1319 4.00033 10.5001C4.00033 10.8683 3.70185 11.1667 3.33366 11.1667H2.66699C2.13656 11.1667 1.62785 10.956 1.25278 10.581C0.877706 10.2059 0.666992 9.69718 0.666992 9.16675V3.16675C0.666992 2.63632 0.877706 2.12761 1.25278 1.75253C1.62785 1.37746 2.13656 1.16675 2.66699 1.16675H8.66699C9.19743 1.16675 9.70613 1.37746 10.0812 1.75253C10.4563 2.12761 10.667 2.63631 10.667 3.16675V3.83341C10.667 4.2016 10.3685 4.50008 10.0003 4.50008C9.63214 4.50008 9.33366 4.2016 9.33366 3.83341V3.16675C9.33366 2.98994 9.26342 2.82037 9.1384 2.69534C9.01337 2.57032 8.8438 2.50008 8.66699 2.50008H2.66699Z"
                      fill="#557EFB"
                    />
                  </svg>
                </div>
              </b-card-text>

              <div class="collapse-foot">
                <button
                  class="btn-simple-primary"
                  @click="showMsgModal('text', session)"
                >
                  SEND TEXT
                </button>
                <button
                  class="btn-simple-primary"
                  @click="showMsgModal('email', session)"
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.66699 4.33333C2.30185 4.33333 2.00033 4.63486 2.00033 5V13C2.00033 13.3651 2.30185 13.6667 2.66699 13.6667H13.3337C13.6988 13.6667 14.0003 13.3651 14.0003 13V5C14.0003 4.63486 13.6988 4.33333 13.3337 4.33333H2.66699ZM0.666992 5C0.666992 3.89848 1.56547 3 2.66699 3H13.3337C14.4352 3 15.3337 3.89848 15.3337 5V13C15.3337 14.1015 14.4352 15 13.3337 15H2.66699C1.56547 15 0.666992 14.1015 0.666992 13V5Z"
                        fill="#557EFB"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.787561 4.61791C0.998704 4.31628 1.41439 4.24292 1.71602 4.45407L8.00038 8.85312L14.2847 4.45407C14.5864 4.24292 15.0021 4.31628 15.2132 4.61791C15.4243 4.91954 15.351 5.33523 15.0494 5.54637L8.38269 10.213C8.15314 10.3737 7.84762 10.3737 7.61807 10.213L0.951408 5.54637C0.649775 5.33523 0.576419 4.91954 0.787561 4.61791Z"
                        fill="#557EFB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  SEND EMAIL
                </button>
                <button
                  @click="openSessions"
                  class="btn-simple-primary btn-start"
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 13.5H2C1.73478 13.5 1.48043 13.3946 1.29289 13.2071C1.10536 13.0196 1 12.7652 1 12.5V4.5C1 4.23478 1.10536 3.98043 1.29289 3.79289C1.48043 3.60536 1.73478 3.5 2 3.5H10.5C10.7652 3.5 11.0196 3.60536 11.2071 3.79289C11.3946 3.98043 11.5 4.23478 11.5 4.5V6.53L14.21 4.595C14.2846 4.54187 14.3724 4.51025 14.4638 4.50362C14.5552 4.49698 14.6466 4.51557 14.7281 4.55737C14.8096 4.59916 14.8781 4.66254 14.926 4.7406C14.974 4.81866 14.9996 4.90839 15 5V12C14.9996 12.0916 14.974 12.1813 14.926 12.2594C14.8781 12.3375 14.8096 12.4008 14.7281 12.4426C14.6466 12.4844 14.5552 12.503 14.4638 12.4964C14.3724 12.4897 14.2846 12.4581 14.21 12.405L11.5 10.47V12.5C11.5 12.7652 11.3946 13.0196 11.2071 13.2071C11.0196 13.3946 10.7652 13.5 10.5 13.5Z"
                      fill="#557EFB"
                    />
                  </svg>
                  START SESSION
                </button>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div v-if="sessionsToDisplay.length == 0 && searchStr.trim() == ''">
        You have no {{ activeTab }} sessions.
      </div>
      <div v-if="results.length == 0 && searchStr.trim() !== ''">
        No Results.
      </div>
      <modal :id="sessionModal">
        <div class="add-plan" v-if="!del">
          <span class="close-icon" @click="cancelAction">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>{{ add ? "Create" : "Edit" }} Connection</h3>
          <div class="h-18"></div>
          <b-form-group label="Sessions Title">
            <b-form-input
              type="text"
              required
              v-model="session.title"
              placeholder="Enter your sessions title here"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="textarea-scroll" label="Session Summary">
            <b-form-textarea
              id="textarea-default"
              rows="5"
              no-resize
              v-model="session.summary"
              placeholder="Enter your sessions summary here"
              @focus="limitWords"
            ></b-form-textarea>
            <span class="counter">{{ session.summary.length }}/300</span>
          </b-form-group>
          <b-form-group label="Date time ">
            <span class="pre"
              >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 5C4.44772 5 4 5.44772 4 6V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2 10C2 9.44771 2.44772 9 3 9H21C21.5523 9 22 9.44771 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <b-form-input
              @click="handleDateClick"
              type="text"
              required
              class="pl-5"
              v-model="session.datetime"
            ></b-form-input>
          </b-form-group>
          <!-- placeholder="Enter your sessions title here" -->
          <div class="digtim">
            <b-form-group label="Session Price">
              <span class="pre">$</span>
              <b-form-input
                type="number"
                required
                v-model="session.price"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Session Duration">
              <span class="post">mins</span>
              <b-form-input
                type="number"
                required
                v-model="session.duration"
              ></b-form-input>
            </b-form-group>
          </div>
          <label class="notification">
            <div class="toggler" :class="[usePassword ? 'bg' : '']">
              <div class="slider" :class="[usePassword ? 'btns' : '']"></div>
            </div>
            <div class="notification-content">
              <h6>
                Use Password
              </h6>
            </div>
            <input type="checkbox" class="invisible" v-model="usePassword" />
          </label>
          <b-form-group v-if="usePassword">
            <b-form-input
              type="password"
              required
              placeholder="Password"
              v-model="session.password"
            ></b-form-input>
          </b-form-group>
          <label class="notification">
            <div class="toggler" :class="[session.geoLocation ? 'bg' : '']">
              <div
                class="slider"
                :class="[session.geoLocation ? 'btns' : '']"
              ></div>
            </div>
            <div class="notification-content">
              <h6>
                Request Geolocation
              </h6>
            </div>
            <input
              type="checkbox"
              class="invisible"
              v-model="session.geoLocation"
            />
          </label>
          <label class="notification">
            <div class="toggler" :class="[addUserInfo ? 'bg' : '']">
              <div class="slider" :class="[addUserInfo ? 'btns' : '']"></div>
            </div>
            <div class="notification-content">
              <h6>
                Add Sessions User Information
              </h6>
            </div>
            <input type="checkbox" class="invisible" v-model="addUserInfo" />
          </label>
          <div v-if="addUserInfo" class="foot">
            <div class="digtim">
              <b-form-group>
                <b-form-input
                  type="text"
                  required
                  placeholder="First Name"
                  v-model="session.user.firstname"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input
                  type="text"
                  required
                  placeholder="Last Name"
                  v-model="session.user.lastname"
                ></b-form-input>
              </b-form-group>
            </div>
            <b-form-group label="Email">
              <b-form-input
                type="email"
                required
                placeholder="Enter email here"
                v-model="session.user.email"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Phone (Opt)">
              <b-form-input
                type="text"
                required
                placeholder="Enter phone number"
                v-model="session.user.phoneNumber"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="foot">
            <div class="d-flex justify-content-between">
              <b-button class="btn-simple" @click="cancelAction">
                Cancel
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                v-if="add"
                @click="handleAddSession"
                :disabled="canGenerateSession"
              >
                Add
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                @click="handleUpdateSession"
                v-else
                :disabled="canGenerateSession"
              >
                Update
              </b-button>
            </div>
          </div>
        </div>
        <div class="add-plan del-faq" v-else>
          <span class="close-icon" @click="$bvModal.hide(sessionModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Session</h3>
          <div class="warning-msg">
            <p>Are you sure want to delete this session?</p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteSession">
              Yes! Delete
            </b-button>
            <b-button class="btn-simple" @click="hideDeleteSession">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
      <!-- :visible="true" -->
      <modal id="sendtext">
        <div class="add-plan">
          <span class="close-icon" @click="$bvModal.hide('sendtext')">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>Send {{ sendEmail ? "Email" : "text" }}</h3>
          <div class="h-18"></div>
          <div v-if="selectedSession.user" class="sendto">
            <b-form-group label="Send to">
              <div class="send-to-profile">
                <img
                  v-if="selectedSession.user.imgURL"
                  :src="selectedSession.user.imgURL"
                  alt=""
                />
                <b-avatar v-else variant="secondary" class="avatar"></b-avatar>

                <div class="info">
                  <h4 class="name">
                    {{
                      selectedSession.user.firstname +
                        "" +
                        selectedSession.user.lastname
                    }}
                  </h4>
                  <h5
                    v-if="sendEmail && selectedSession.user.email"
                    class="contact"
                  >
                    {{ selectedSession.user.email }}
                  </h5>
                  <h5
                    v-if="!sendEmail && selectedSession.user.phoneNumber"
                    class="contact"
                  >
                    {{ selectedSession.user.phoneNumber }}
                  </h5>
                </div>
              </div>
            </b-form-group>
          </div>
          <b-form-group label="Subject Line" v-if="sendEmail">
            <b-form-input
              type="text"
              required
              v-model="msg.subject"
              placeholder="Enter your Email Subject here"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="textarea-scroll" label="Body">
            <b-form-textarea
              id="textarea-default"
              rows="5"
              no-resize
              v-model="msg.body"
              placeholder="Enter your message here"
            ></b-form-textarea>
          </b-form-group>
          <div class="foot email__foot">
            <div class="d-flex justify-content-between">
              <b-button class="btn-simple" @click="$bvModal.hide('sendtext')">
                Cancel
              </b-button>
              <b-button
                variant="primary btn-round-fill"
                @click="sendMsg"
                :disabled="msg.body.trim().length > 0 ? false : true"
              >
                Send
              </b-button>
            </div>
          </div>
        </div>
      </modal>
      <Calendar
          :ref="calendarModal"
          :id="calendarModal"
          @updateDate="updateDateTime"
      />
    </div>
    <add-edit-session-modal
      :ref="sessionModalId"
      :modal-id="sessionModalId"
      @add-publishing="handleAddSession"
      @update-publishing="handleUpdateSession"
    />
  </div>
</template>

<script>
import moment from "moment";
import sendNotification from "@/services/sendNotification";
import Modal from "@/components/common/modal";
import Calendar from "@/components/common/calendar";
import AddEditSessionModal from "./addEditSessionModal";
export default {
  components: {
    Calendar,
    Modal,
    AddEditSessionModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  beforeMount() {
    this.fetching = true;
  },
  mounted() {
    console.log("session => ", this.session);
    this.getSessionsForUser();
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }

      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
  },
  computed: {
    canGenerateSession() {
      return !(this.session.title && this.session.title.length > 0);
    },
    results() {
      if (this.searchStr.trim() == "") return this.sessionsToDisplay;

      return this.sessionsToDisplay.filter(session => {
        return (
          session.plan.title
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          session.plan.summary
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          session.user.firstname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          session.user.lastname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        );
      });
    }
  },
  methods: {
    handleDateClick() {
      debugger
      this.$bvModal.show(this.calendarModal);
    },
    handleCreatSessionModalClick() {
      this.$bvModal.show(this.sessionModal);
    },
    limitWords() {
      document.getElementById("bio").setAttribute("maxlength", 300);
    },
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    showTabSessions(tab) {
      if (tab) {
        this.activeTab = tab;
      }
      if (this.activeTab == "upcoming") {
        this.sessionsToDisplay = this.allSessions.filter(
          session => session._booked_at.toDate() >= new Date()
        );
      } else if (this.activeTab == "past") {
        this.sessionsToDisplay = this.allSessions.filter(
          session => session._booked_at.toDate() < new Date()
        );
      } else if (this.activeTab == "cancelled") {
        this.sessionsToDisplay = [];
      }
      console.log(this.sessionsToDisplay);
    },
    generateLink(name, code) {
      return `${process.env.VUE_APP_BASE_URL}/sessions/${name}?code=${code}`;
    },
    getTimeDateString(timestamp) {
      let day = this.days[timestamp.getDay()];
      let date = timestamp.getDate();
      let month = this.months[timestamp.getMonth()];
      let time = timestamp.toLocaleTimeString();
      let str = `${day}, ${month} ${date}, ${time.substring(
        0,
        5
      )} ${time.substring(8, 11)}`;
      return str;
    },
    getSessionsForUser() {
      this.$store
        .dispatch("user/getListGuideSessions")
        .then(data => {
          console.log(data);
          if (data.length > 0) {
            this.allSessions = data;
            this.showTabSessions();
          }
          this.fetching = false;
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
          this.fetching = false;
        });
    },
    openSessions() {
      const windowFeatures =
        "width=1280,height=720,toolbar=no, menubar=no, resizable=yes";
      window.open(`sessions`, "newwindow", windowFeatures);
    },
    handleAddSession() {
      debugger;
      let time = null;
      if (this.session.datetime) {
        time = moment(this.session.datetime, "DD-MM-YYYY hh:mm:ss").toDate();
      }
      let sessionCode = this.getSessionId(3) + `F${moment().unix()}`;
      let user = this.$store.getters["user/user"];
      let payload = {
        _booked_at: time,
        room_id: `${user.uid}_${sessionCode}`,
        session_code: sessionCode,
        password: this.usePassword ? this.session.password : "",
        geoLocation: this.session.geoLocation,
        guide: {
          user_id: this.$store.getters["user/user"].uid,
          firstname: this.$store.getters["user/profile"].firstname,
          lastname: this.$store.getters["user/profile"].lastname,
          imgURL: this.$store.getters["user/profile"].imgURL,
          email: this.$store.getters["user/profile"].email,
          profileName: this.$store.getters["user/profile"]._dashboards.guide
            .profileName
        },
        user: this.addUserInfo
          ? {
              firstname: this.session.user.firstname,
              lastname: this.session.user.lastname,
              email: this.session.user.email,
              phoneNumber: this.session.user.phoneNumber,
              imgURL: null
            }
          : {},
        plan: {
          id: 0,
          price: this.session.price,
          duration: this.session.duration,
          title: this.session.title,
          summary: this.session.summary
        }
      };
      this.$store
        .dispatch("session/createSessionInvite", payload)
        .then(() => {
          this.getSessionsForUser();
          this.showTabSessions();
          this.$bvModal.hide(this.sessionModal);
          this.resetForm();
          this.$store.dispatch("user/showNotification", {
            title: `'${this.session.title}' Session Generated`,
            description: "Awesome! You will receive an email.",
            variant: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    getSessionId(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    updateDateTime(dateTime) {
      this.session.datetime = dateTime.date.format + " " + dateTime.time;
      this.$bvModal.hide(this.calendarModal);
    },
    copytoClipboard(link) {
      navigator.clipboard.writeText(link);
      this.link = "Copied!";
    },
    changeMessage() {
      setTimeout(() => {
        this.link = "Copy to clipboard";
      }, 300);
    },
    cancelAction() {
      this.$bvModal.hide(this.sessionModal);
      this.resetForm();
    },
    showEditSession(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;

      this.session.price = this.results[i].plan.price || "";
      this.session.duration = this.results[i].plan.duration || "";
      this.session.title = this.results[i].plan.title || "";
      this.session.summary = this.results[i].plan.summary || "";
      this.session.password = this.results[i].password || "";
      this.session.geoLocation = this.results[i].geoLocation || false;
      this.session.datetime =
        this.getTimeDateString(this.results[i]._booked_at.toDate()) || "";
      this.session.user.firstname = this.results[i].user.firstname || "";
      this.session.user.lastname = this.results[i].user.lastname || "";
      this.session.user.email = this.results[i].user.email || "";
      this.session.user.phoneNumber = this.results[i].user.phoneNumber || "";
      if (this.results[i].password) this.usePassword = true;
      if (this.results[i].user) this.addUserInfo = true;
      this.$bvModal.show(this.sessionModal);
    },
    handleUpdateSession() {
      let time = null;
      if (this.session.datetime) {
        time = moment(this.session.datetime, "YYYY-MM-DD hh:mm:ss").toDate();
      }
      let payload = {
        _booked_at: time,
        room_id: this.results[this.activeIndex].room_id,
        password: this.usePassword ? this.session.password : "",
        geoLocation: this.session.geoLocation,
        guide: {
          user_id: this.$store.getters["user/user"].uid,
          firstname: this.$store.getters["user/profile"].firstname,
          lastname: this.$store.getters["user/profile"].lastname,
          imgURL: this.$store.getters["user/profile"].imgURL,
          profileName: this.$store.getters["user/profile"]._dashboards.guide
            .profileName
        },
        user: this.addUserInfo
          ? {
              firstname: this.session.user.firstname,
              lastname: this.session.user.lastname,
              email: this.session.user.email,
              phoneNumber: this.session.user.phoneNumber,
              imgURL: null
            }
          : {},
        plan: {
          id: 0,
          price: this.session.price,
          duration: this.session.duration,
          title: this.session.title,
          summary: this.session.summary
        }
      };
      this.$store
        .dispatch("session/updateGuideSession", payload)
        .then(() => {
          this.$bvModal.hide(this.sessionModal);
          this.resetForm();
          this.$store.dispatch("user/showNotification", {
            title: `'${this.session.title}' Session Updated`,
            description: "Session Details Updated.",
            variant: "success"
          });
          this.getSessionsForUser();
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    showMsgModal(type, session) {
      if (type == "email") {
        this.sendEmail = true;
      } else {
        this.sendEmail = false;
      }
      this.selectedSession = session;
      this.$bvModal.show("sendtext");
    },
    sendMsg() {
      let user = [];
      if (this.sendEmail) {
        if (this.selectedSession.user.user_id) {
          user.push(this.selectedSession.user.user_id.id);
        } else {
          user.push({ email: this.selectedSession.user.email });
        }
        sendNotification(
          this.msg.subject,
          user,
          ["email"],
          this.msg.body,
          "JourneyBinder",
          "d-32d0699b4b634609a39ce9b2340ca363"
        )
          .then(res => {
            this.$bvModal.hide("sendtext");
            this.$store.dispatch("user/showNotification", {
              title: "Email Sent.",
              description: this.msg.body,
              variant: "success"
            });
            this.msg.subject = "";
            this.msg.body = "";
            console.log("Email sent.", res);
          })
          .catch(e => {
            console.log("error", e);
          });
      } else {
        if (this.selectedSession.user.user_id) {
          user.push(this.selectedSession.user.user_id.id);
        } else {
          user.push({ phoneNumber: this.selectedSession.user.phoneNumber });
        }
        sendNotification(
          this.msg.subject,
          user,
          ["sms"],
          this.msg.body,
          "JourneyBinder",
          ""
        )
          .then(res => {
            this.$bvModal.hide("sendtext");
            this.$store.dispatch("user/showNotification", {
              title: "Text Message Sent.",
              description: "this.msg.body",
              variant: "success"
            });
            this.msg.subject = "";
            this.msg.body = "";
            console.log("Sms sent.", res);
          })
          .catch(e => {
            console.log("error", e);
          });
      }
    },
    resetForm() {
      this.session = {
        price: "",
        duration: "",
        link: "",
        title: "",
        summary: "",
        password: "",
        geoLocation: false,
        datetime: "Day, Month Date, 00:00 AM",
        imgURL: null,
        user: {
          firstname: "",
          lastname: "",
          email: "",
          phoneNumber: ""
        }
      };
      this.usePassword = false;
      this.addUserInfo = false;
    }
    // showDeleteSession(i) {
    //   this.del = true;
    //   this.activeIndex = i;
    //   this.$bvModal.show(this.sessionModal);
    // },
    // deleteSession() {
    //   this.sessions.splice(this.activeIndex, 1);
    //   this.$bvModal.hide(this.sessionModal);
    // },
    // hideDeleteSession() {
    //   this.$bvModal.hide(this.sessionModal);
    // }
  },
  data() {
    return {
      sessionModalId: "add-edit-session-modal",
      sessionModal: "session-modal", //@toDo-Remove
      fetching: false,
      msg: {
        subject: "",
        body: ""
      },
      sessionsToDisplay: [],
      sendEmail: true,
      calendarModal: "calendar-modal-sessions",
      add: true,
      del: false,
      usePassword: false,
      addUserInfo: false,
      activeTab: "upcoming",
      activeIndex: -1,
      activeCollapse: -1,
      link: "Copy to clipboard",
      isJustShown: false,
      searchStr: "",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      session: {
        price: "",
        duration: "",
        title: "",
        summary: "",
        password: "",
        geoLocation: false,
        datetime: "Day, Month Date, 00:00 AM",
        imgURL: null,
        user: {
          firstname: "",
          lastname: "",
          email: "",
          phoneNumber: ""
        }
      },
      selectedSession: {},
      allSessions: []
    };
  }
};
</script>

<style lang="scss" scoped>
.collapse-foot {
  display: flex;
  justify-content: flex-end;
  .btn-simple-primary {
    background-color: #fff;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    justify-content: center;
    padding: 8px 16px;
    border: none;
    display: flex;
    letter-spacing: 0.05em;
    align-items: center;
    color: #557efb;
    margin-left: 16px;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;
    svg {
      margin-right: 16px;
    }
    &:hover {
      background-color: #f3f6f9;
    }
    &.btn-start {
      background-color: #f3f6f9;
      &:hover {
        background-color: #dfdfdf;
        box-shadow: 0px 0px 4px 0px #eee;
      }
    }
  }
}
.edit-link {
  display: flex;
  align-items: center;
  svg {
    cursor: pointer;
  }
  p {
    margin: 0;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;

    /* Body */

    color: #474d52;
  }
}
.tabs-filter {
  padding: 16px 0;
  .btn-round-fill {
    margin-right: 16px;
    border-radius: 8px !important;
    background-color: #f3f6f9 !important;
    color: #474d52 !important;
    font-weight: normal !important;
    width: unset !important;
    border: none !important;
    &:hover,
    &.active {
      background-color: #557efb !important;
      color: #fff !important;
    }
  }
}
.link {
  cursor: pointer;
  .link-title {
    color: #8d99a0;
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.digtim {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-sessions {
  border: none;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #557efb;
  cursor: pointer;
  background: none;
  position: relative;
}
.add-sessions:hover {
  box-shadow: none;
}
.add-plan {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-faq {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.faqs {
  margin-top: 20px;
  padding-right: 20px;
  @media (min-width: 556px) {
    height: 40vh;
    overflow-y: scroll;
  }
  &::-webkit-scrollbar {
    width: 6px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 16px;
  }
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 1px;
          margin-top: -1px;
        }
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .email,
    .delete {
      display: none;
      cursor: pointer;
    }
    .datetime {
      display: none !important;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      color: #8d99a0;
    }
    .btn-collapse {
      padding: 24px;
      display: grid;
      grid-template-columns: 40px 1fr;
      grid-column-gap: 10px;
      align-items: center;
      text-align: left;
      box-shadow: none;
      img {
        height: 40px;
        width: 40px;
        border-radius: 50%;
      }
      .avatar {
        width: 50px !important;
        height: 42px !important;
      }
      .name {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        display: block;
      }
      .email {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        display: none;
        align-items: center;

        color: #8d99a0;
      }
    }
    &.active {
      grid-template-columns: 1fr 180px 25px 30px;
      .datetime,
      .edit {
        display: block !important;
      }
      // .datetime,
      // .edit,
      // .delete {
      //   display: block !important;
      // }
      .email {
        display: flex !important;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
  }
}
.email__foot {
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
}
.sendto {
  margin-bottom: 24px;
  .send-to-profile {
    display: grid;
    grid-template-columns: 40px 1fr;
    grid-column-gap: 16px;
    img {
      border-radius: 50%;
      height: 40px;
      width: 40px;
      object-fit: cover;
    }
    .info {
      .name {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        margin: 0;
        margin-bottom: 3px;
      }
      .contact {
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
        margin: 0;
      }
    }
  }
}
.disabled {
  opacity: 0.7;
}
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .disabled {
    opacity: 0.7;
  }
  .notification-content {
    margin-top: 11px;
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: #557efb;
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.counter {
  font-size: 12px;
  float: right;
}
</style>
